import React from "react";
import { NavLink } from "react-router-dom";

const NotFound = () => {
  return (
    <React.Fragment>
      <h1
        style={{
          display: "flex",
          justifyContent: "center",
          color: "grey",
          fontWeight: "bolder",
          marginTop: "180px",
        }}
      >
        Page Not Found
      </h1>
      <h1
        style={{
          display: "flex",
          justifyContent: "center",
          color: "#A6226C",
          fontWeight: "bolder",
          marginTop: "30px",
        }}
      >
        <NavLink style={{ color: "#A6226C" }} to="/dashboard">
          Go To Dashboard
        </NavLink>
      </h1>
    </React.Fragment>
  );
};

export default NotFound;
